import { media, styled } from '@styles';

export const Wrapper = styled.div`
  position: relative;
  margin: 0 auto;
  width: 100%;
  ${media.smallScreen`
    height: 100vw;
  `}
`;
